/* Mercado Vital — home interactions */
(function () {
  'use strict';

  // Nav pill active state based on current path
  document.addEventListener('DOMContentLoaded', function () {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    var links = document.querySelectorAll('nav.main a[href]');
    links.forEach(function (a) { a.classList.remove('active'); });
    links.forEach(function (a) {
      var href = (a.getAttribute('href') || '').replace(/\/+$/, '') || '/';
      if (href === path) a.classList.add('active');
    });
  });

  // Dropdown submenus: toggle on click (mobile-friendly), close on outside click
  document.addEventListener('DOMContentLoaded', function () {
    var groups = document.querySelectorAll('[data-mv-nav-group]');
    groups.forEach(function (group) {
      var trigger = group.querySelector('.nav-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        // En mobile (<900px) prevenimos la navegación para abrir el submenu
        if (window.innerWidth < 900) {
          e.preventDefault();
          var wasOpen = group.classList.contains('open');
          // Cerrar todos
          groups.forEach(function (g) { g.classList.remove('open'); });
          if (!wasOpen) {
            group.classList.add('open');
            trigger.setAttribute('aria-expanded', 'true');
          } else {
            trigger.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mv-nav-group]')) {
        groups.forEach(function (g) {
          g.classList.remove('open');
          var t = g.querySelector('.nav-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        groups.forEach(function (g) { g.classList.remove('open'); });
      }
    });
  });

  // ─── PLP interactions ────────────────────────────────────────────────
  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Facet collapse
    document.querySelectorAll('[data-mv-facet] .facet-head').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var facet = btn.parentElement;
        var isClosed = facet.classList.toggle('closed');
        btn.setAttribute('aria-expanded', isClosed ? 'false' : 'true');
      });
    });

    // Filter form auto-submit on change (debounced for range inputs)
    var filterForm = document.querySelector('[data-mv-filters-form]');
    if (filterForm) {
      var submitForm = function () { filterForm.submit(); };
      var debouncedSubmit = debounce(submitForm, 400);

      filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
        inp.addEventListener('change', submitForm);
      });
      filterForm.querySelectorAll('input[type="number"]').forEach(function (inp) {
        inp.addEventListener('change', debouncedSubmit);
        inp.addEventListener('blur', submitForm);
      });
    }

    // Price range dual-slider: sync thumbs <-> number inputs + update fill
    document.querySelectorAll('[data-mv-range]').forEach(function (slider) {
      var rmax = parseFloat(slider.dataset.mvRangeMax) || 0;
      if (!rmax) return;
      var thumbMin = slider.querySelector('[data-mv-range-thumb="min"]');
      var thumbMax = slider.querySelector('[data-mv-range-thumb="max"]');
      var fill = slider.querySelector('[data-mv-range-fill]');
      var facet = slider.closest('.facet');
      var numMin = facet ? facet.querySelector('[data-mv-range-number="min"]') : null;
      var numMax = facet ? facet.querySelector('[data-mv-range-number="max"]') : null;

      function clampAndPaint(changedThumb) {
        var lo = parseFloat(thumbMin.value) || 0;
        var hi = parseFloat(thumbMax.value);
        if (isNaN(hi)) hi = rmax;
        if (changedThumb === 'min' && lo > hi) { lo = hi; thumbMin.value = lo; }
        if (changedThumb === 'max' && hi < lo) { hi = lo; thumbMax.value = hi; }
        var loPct = (lo / rmax) * 100;
        var hiPct = (hi / rmax) * 100;
        fill.style.left = loPct + '%';
        fill.style.right = (100 - hiPct) + '%';
        if (numMin) numMin.value = lo > 0 ? lo : '';
        if (numMax) numMax.value = hi < rmax ? hi : '';
      }

      thumbMin.addEventListener('input', function () { clampAndPaint('min'); });
      thumbMax.addEventListener('input', function () { clampAndPaint('max'); });

      thumbMin.addEventListener('change', function () {
        if (numMin) numMin.dispatchEvent(new Event('change', { bubbles: true }));
      });
      thumbMax.addEventListener('change', function () {
        if (numMax) numMax.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (numMin) numMin.addEventListener('input', function () {
        var v = parseFloat(numMin.value);
        if (!isNaN(v)) { thumbMin.value = Math.min(Math.max(v, 0), rmax); clampAndPaint('min'); }
      });
      if (numMax) numMax.addEventListener('input', function () {
        var v = parseFloat(numMax.value);
        if (!isNaN(v)) { thumbMax.value = Math.min(Math.max(v, 0), rmax); clampAndPaint('max'); }
      });

      clampAndPaint(null);
    });

    // Sort select: submit form on change (reemplaza onchange inline)
    document.querySelectorAll('[data-mv-sort-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (form) form.submit();
      });
    });

    // View toggle (grid / list)
    var grid = document.querySelector('[data-mv-plp-grid]');
    document.querySelectorAll('[data-mv-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-mv-view');
        if (grid) grid.classList.toggle('list', mode === 'list');
        document.querySelectorAll('[data-mv-view]').forEach(function (b) {
          var on = b.getAttribute('data-mv-view') === mode;
          b.classList.toggle('on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        try { localStorage.setItem('mvPlpView', mode); } catch (e) {}
      });
    });

    // Mobile filter drawer
    var openers = document.querySelectorAll('[data-mv-open-filters]');
    var closers = document.querySelectorAll('[data-mv-close-filters]');
    var drawer = document.querySelector('.mv-plp-main .filters');

    function openDrawer() {
      document.body.classList.add('mv-filters-open');
      if (drawer) drawer.setAttribute('aria-modal', 'true');
    }
    function closeDrawer() {
      document.body.classList.remove('mv-filters-open');
      if (drawer) drawer.removeAttribute('aria-modal');
    }

    openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
    closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('mv-filters-open')) {
        closeDrawer();
      }
    });

    // Swipe-down-to-close del drawer de filtros (mobile bottom sheet).
    if (drawer) {
      var THRESHOLD = 60;        // px verticales para confirmar cierre
      var DIR_LOCK = 8;
      var startX = 0, startY = 0, deltaY = 0;
      var dragging = false, locked = false;

      function inHandleArea(target) {
        return !!target.closest('.filters-drawer-head') || !!target.closest('.filters-drawer-close');
      }

      // setProperty con 'important' es necesario porque el CSS tiene
      // `transform: translateY(0) !important` cuando el drawer está abierto.
      function setTransform(val) {
        if (val === '') drawer.style.removeProperty('transform');
        else drawer.style.setProperty('transform', val, 'important');
      }
      function setTransition(val) {
        if (val === '') drawer.style.removeProperty('transition');
        else drawer.style.setProperty('transition', val, 'important');
      }

      function onStart(clientX, clientY, target) {
        if (!document.body.classList.contains('mv-filters-open')) return;
        if (!inHandleArea(target) && drawer.scrollTop > 0) return;
        if (target.closest('button, a, input, select, textarea, [contenteditable]') && !inHandleArea(target)) return;
        startX = clientX;
        startY = clientY;
        deltaY = 0;
        dragging = true;
        locked = false;
      }

      function onMove(clientX, clientY, e) {
        if (!dragging) return;
        var dx = clientX - startX;
        var dy = clientY - startY;
        if (!locked) {
          if (Math.abs(dx) < DIR_LOCK && Math.abs(dy) < DIR_LOCK) return;
          if (Math.abs(dx) > Math.abs(dy) || dy < 0) { dragging = false; return; }
          locked = true;
          setTransition('none');
        }
        deltaY = Math.max(0, dy);
        setTransform('translateY(' + deltaY + 'px)');
        if (e && e.cancelable) e.preventDefault();
      }

      function onEnd() {
        if (!dragging) return;
        var shouldClose = locked && deltaY > THRESHOLD;
        dragging = false;
        locked = false;
        setTransition('');
        setTransform('');
        if (shouldClose) closeDrawer();
      }

      // Touch events — más confiables que pointer events en algunos móviles
      drawer.addEventListener('touchstart', function (e) {
        if (!e.touches[0]) return;
        onStart(e.touches[0].clientX, e.touches[0].clientY, e.target);
      }, { passive: true });
      drawer.addEventListener('touchmove', function (e) {
        if (!e.touches[0]) return;
        onMove(e.touches[0].clientX, e.touches[0].clientY, e);
      }, { passive: false });
      drawer.addEventListener('touchend', onEnd, { passive: true });
      drawer.addEventListener('touchcancel', onEnd, { passive: true });
    }
  });

  // ─── Variant picker (+ en tarjetas home) ─────────────────────────────
  // El panel se mueve a document.body al abrir (DOM portal) para evadir el
  // overflow-x:auto del carrusel que ancla position:fixed al scroller en
  // Webkit. WeakMap guarda el parent original para devolverlo al cerrar.
  var variantPanelHomes = new WeakMap();   // wrap -> { panel, parent }
  var variantPanelOwners = new WeakMap();  // panel -> wrap (para resolver wrap desde el panel flotante)

  // Pausa el scroll-snap de los carruseles del home mientras hay panels
  // abiertos: evita que el click en el + dispare un "snap" al card más
  // cercano (lo que se siente como un brinco raro al abrir el menú).
  function setCarouselSnap(disabled) {
    document.querySelectorAll('.mv-grid-block .products').forEach(function (c) {
      c.style.scrollSnapType = disabled ? 'none' : '';
    });
  }

  function unmountFloatingPanel(wrap) {
    var home = variantPanelHomes.get(wrap);
    if (!home) return;
    var panel = home.panel;
    if (panel.parentNode === document.body) {
      home.parent.appendChild(panel);
    }
    panel.classList.remove('is-floating');
    panel.style.top = '';
    panel.style.left = '';
    variantPanelOwners.delete(panel);
    variantPanelHomes.delete(wrap);
    // Restaurar scroll-snap solo cuando ya no haya ningún panel flotante.
    if (!document.querySelector('.card-variant-panel.is-floating')) {
      setCarouselSnap(false);
    }
  }

  // Resuelve el wrap dueño de un click target, considerando que el panel
  // puede estar flotando en body (sin ancestor data-mv-variant-wrap).
  function wrapFromTarget(target) {
    var w = target.closest('[data-mv-variant-wrap]');
    if (w) return w;
    var floatingPanel = target.closest('.card-variant-panel.is-floating');
    return floatingPanel ? variantPanelOwners.get(floatingPanel) : null;
  }

  function closeAllVariantPanels(except) {
    document.querySelectorAll('.card-add-wrap.open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('open');
      var t = w.querySelector('[data-mv-variant-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
      unmountFloatingPanel(w);
    });
  }

  // Mueve el panel al body, le aplica .is-floating y calcula top/left
  // contra el viewport (rect del + button).
  function positionVariantPanel(wrap) {
    var toggle = wrap.querySelector('[data-mv-variant-toggle]');
    // si ya está flotando, busca el panel via WeakMap; si no, búscalo dentro del wrap
    var existing = variantPanelHomes.get(wrap);
    var panel = existing ? existing.panel : wrap.querySelector('[data-mv-variant-panel]');
    if (!toggle || !panel) return;
    if (!existing) {
      setCarouselSnap(true);
      variantPanelHomes.set(wrap, { panel: panel, parent: panel.parentNode });
      variantPanelOwners.set(panel, wrap);
      document.body.appendChild(panel);
      panel.classList.add('is-floating');
    }
    var btn = toggle.getBoundingClientRect();
    var pw = panel.offsetWidth || 220;
    var ph = panel.offsetHeight || 200;
    var gap = 10;
    var top = btn.top - ph - gap;
    var left = btn.right - pw;
    if (top < 8) top = btn.bottom + gap;
    if (left < 8) left = 8;
    if (left + pw > window.innerWidth - 8) left = window.innerWidth - pw - 8;
    panel.style.top = top + 'px';
    panel.style.left = left + 'px';
  }

  function getMvCartBadgeCount() {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return 0;
    var n = parseInt((badge.textContent || '').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  function addVariantToCart(variantId) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', window.location.pathname);
    }
    // Optimistic UI: subimos el contador del icono inmediatamente para que
    // el feedback sea instantáneo. El fetch corre en background y el
    // response real reconcilia el contador. Si falla, revertimos.
    var prevCount = getMvCartBadgeCount();
    var badges = document.querySelectorAll('[data-cart-count]');
    applyMvCartBadgeCount(badges, prevCount + 1);
    cartOpsActive++;
    var settleOp = function () {
      cartOpsActive = Math.max(0, cartOpsActive - 1);
    };
    // No abrimos el drawer al agregar — el usuario lo abre manualmente.
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) {
        throw new Error(res.description || res.message || 'cart-error');
      }
      if (cart && typeof cart.renderContents === 'function') {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
      updateMvCartBadge(res);
      settleOp();
      // Re-sync counters de qty controls (en caso de que esta variant sea
      // single-variant y aparezca con su contador en otro carrusel).
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(syncAllQtyControlsFromCart)
        .catch(function () {});
      return res;
    }).catch(function (err) {
      settleOp();
      // Revertir el badge optimista si el fetch falló.
      applyMvCartBadgeCount(document.querySelectorAll('[data-cart-count]'), prevCount);
      throw err;
    });
  }

  function updateMvCartBadge(res) {
    var badges = document.querySelectorAll('[data-cart-count]');
    if (!badges.length) return;
    var count = null;
    if (res && res.sections && res.sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      var bubbleNum = doc.querySelector('.cart-count-bubble [aria-hidden="true"]');
      if (bubbleNum) count = parseInt(bubbleNum.textContent.trim(), 10);
    }
    if (count == null || isNaN(count)) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { applyServerBadgeIfSettled(c.item_count); })
        .catch(function () {});
      return;
    }
    applyServerBadgeIfSettled(count);
  }

  function applyServerBadgeIfSettled(count) {
    // Solo aplicamos el item_count del server cuando esta op es la última
    // (cartOpsActive ≤ 1 = solo nosotros, aún no decrementado). Si hay otras
    // ops pendientes, el badge optimista refleja clicks que el server aún no
    // conoce — pisarlo causa el flicker que el usuario reporta.
    if (cartOpsActive > 1) return;
    applyMvCartBadgeCount(document.querySelectorAll('[data-cart-count]'), count);
  }

  function applyMvCartBadgeCount(badges, count) {
    badges.forEach(function (b) {
      b.textContent = String(count);
      if (count > 0) b.removeAttribute('hidden');
      else b.setAttribute('hidden', '');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mv-variant-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrap = toggle.closest('[data-mv-variant-wrap]');
      if (!wrap) return;
      var willOpen = !wrap.classList.contains('open');
      closeAllVariantPanels(willOpen ? wrap : null);
      wrap.classList.toggle('open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) positionVariantPanel(wrap);
      return;
    }

    var pill = e.target.closest('[data-mv-variant-id]');
    if (pill) {
      e.preventDefault();
      if (pill.hasAttribute('disabled')) return;
      if (pill.classList.contains('loading')) return;
      // UI inmediata: cerrar panel y dar feedback breve. El fetch corre en
      // background mientras el usuario sigue navegando.
      var wrap = wrapFromTarget(pill);
      if (wrap) {
        wrap.classList.remove('open');
        var t = wrap.querySelector('[data-mv-variant-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
        unmountFloatingPanel(wrap);
      }
      pill.classList.add('loading');
      setTimeout(function () { pill.classList.remove('loading'); }, 180);
      addVariantToCart(pill.getAttribute('data-mv-variant-id'))
        .catch(function (err) { console.error('[mv] cart add failed', err); });
      return;
    }

    if (!wrapFromTarget(e.target)) {
      closeAllVariantPanels(null);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllVariantPanels(null);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mv-add-direct]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], .card-add');
    if (btn && btn.classList.contains('loading')) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    if (btn) {
      btn.classList.add('loading');
      setTimeout(function () { btn.classList.remove('loading'); }, 180);
    }
    addVariantToCart(idInput.value)
      .catch(function (err) { console.error('[mv] cart add failed', err); });
  });

  // ─── Stepper de cantidad inline en cards single-variant ──────────────
  // 3 estados: "add" (qty=0, botón +), "expanded" (recién interactuado,
  // stepper [−][N][+]) y "collapsed" (qty>0 sin uso ≥10s, círculo con N).
  // Sincronizado en todas las cards del mismo variant_id y con el drawer.
  var QTY_COLLAPSE_MS = 10000;
  var QTY_FETCH_DEBOUNCE_MS = 600;
  var qtyCollapseTimers = {}; // variantId -> timeout id
  var qtyPendingFetch = {};   // variantId -> { timer, lastQty, prevQty, prevBadge }
  var qtyInFlight = {};       // variantId -> count de fetches en vuelo (post-debounce, pre-respuesta)
  var qtyFetchSeq = {};       // variantId -> seq monotónico; solo el último fetch aplica sync (evita race)
  var qtyJustChanged = {};    // variantId -> timestamp del último click optimistic; bloquea syncs non-authoritative durante el guard
  var QTY_OPTIMISTIC_GUARD_MS = 4000;
  var cartOpsActive = 0;      // total de ops del usuario sin reconciliar con server (clicks +/- + addVariantToCart)

  function setQtyOnWrap(wrap, qty, force) {
    var vid = wrap.getAttribute('data-variant-id');
    var currentQty = parseInt(wrap.getAttribute('data-qty'), 10) || 0;
    // Defensa: durante el guard window, no permitir REGRESIÓN del optimistic UI
    // (solo bloquea decrementos; los incrementos del usuario sí pasan porque vienen con force=true).
    if (!force && qtyJustChanged[vid] && (Date.now() - qtyJustChanged[vid]) < QTY_OPTIMISTIC_GUARD_MS && qty < currentQty) {
      return;
    }
    wrap.setAttribute('data-qty', String(qty));
    var num = wrap.querySelector('[data-mv-qty-num]');
    if (num) num.textContent = String(qty);
    var bubbleNum = wrap.querySelector('[data-mv-qty-bubble-num]');
    if (bubbleNum) bubbleNum.textContent = String(qty);
    // Disable los botones + cuando se alcanza el stock máximo del variant
    var maxQty = parseInt(wrap.getAttribute('data-max-qty'), 10);
    var atMax = !isNaN(maxQty) && qty >= maxQty;
    wrap.querySelectorAll('[data-mv-qty-add], [data-mv-qty-plus]').forEach(function (btn) {
      if (atMax) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('title', 'Stock máximo: ' + maxQty);
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('title');
      }
    });
  }

  function setStateOnWrap(wrap, state) {
    wrap.setAttribute('data-state', state);
  }

  function scheduleCollapse(variantId) {
    if (qtyCollapseTimers[variantId]) clearTimeout(qtyCollapseTimers[variantId]);
    qtyCollapseTimers[variantId] = setTimeout(function () {
      var sel = '[data-mv-qty-wrap][data-variant-id="' + variantId + '"]';
      document.querySelectorAll(sel).forEach(function (w) {
        var q = parseInt(w.getAttribute('data-qty'), 10) || 0;
        if (q > 0) setStateOnWrap(w, 'collapsed');
      });
      delete qtyCollapseTimers[variantId];
    }, QTY_COLLAPSE_MS);
  }

  function expandWrap(wrap, variantId) {
    setStateOnWrap(wrap, 'expanded');
    scheduleCollapse(variantId);
  }

  function setQtyOnAllCards(variantId, qty, mode) {
    // mode: 'expand' | 'auto' (collapsed si qty>0, add si qty=0)
    var sel = '[data-mv-qty-wrap][data-variant-id="' + variantId + '"]';
    document.querySelectorAll(sel).forEach(function (w) {
      setQtyOnWrap(w, qty, true); // optimistic, force write
      if (qty <= 0) {
        setStateOnWrap(w, 'add');
      } else if (mode === 'expand') {
        setStateOnWrap(w, 'expanded');
      } else {
        // 'auto': si ya está expanded, dejarlo; si no, collapsed
        if (w.getAttribute('data-state') !== 'expanded') {
          setStateOnWrap(w, 'collapsed');
        }
      }
    });
    if (qty > 0 && mode === 'expand') scheduleCollapse(variantId);
  }

  function syncAllQtyControlsFromCart(cart, opts) {
    // opts.authoritative=true cuando viene de la respuesta de NUESTRO propio
    // fetch — la usamos para forzar la actualización aunque haya in-flight
    // (porque el server ya conoce ese cambio). Sin authoritative, saltamos los
    // variants con optimistic update pendiente para no pisar la UI con un
    // estado stale (caso típico: MutationObserver disparando /cart.js mientras
    // un click optimista aún no ha llegado al servidor).
    var wraps = document.querySelectorAll('[data-mv-qty-wrap]');
    if (!wraps.length) return;
    var skipInFlight = !(opts && opts.authoritative);
    var qtyMap = {};
    (cart && cart.items || []).forEach(function (it) {
      var key = String(it.variant_id);
      qtyMap[key] = (qtyMap[key] || 0) + it.quantity;
    });
    wraps.forEach(function (w) {
      var vid = w.getAttribute('data-variant-id');
      if (skipInFlight && (qtyPendingFetch[vid] || qtyInFlight[vid])) return;
      if (skipInFlight && qtyJustChanged[vid] && (Date.now() - qtyJustChanged[vid]) < QTY_OPTIMISTIC_GUARD_MS) return;
      var q = qtyMap[vid] || 0;
      setQtyOnWrap(w, q);
      var currentState = w.getAttribute('data-state');
      if (q <= 0) {
        setStateOnWrap(w, 'add');
      } else if (currentState !== 'expanded') {
        setStateOnWrap(w, 'collapsed');
      }
    });
  }

  function setVariantQty(variantId, qty) {
    // Usamos /cart/update.js (no /cart/change.js) porque update acepta
    // variant_id y crea/actualiza/elimina line items según convenga. Change
    // requiere un line_id (posición o id de la línea) y falla si pasamos un
    // variant que aún no está en el carrito.
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var payload = { updates: {} };
    payload.updates[String(variantId)] = qty;
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    // Sequence number: si llega otra petición posterior antes que esta responda,
    // descartamos el sync de esta para que la UI no parpadee con el valor stale.
    qtyFetchSeq[variantId] = (qtyFetchSeq[variantId] || 0) + 1;
    var mySeq = qtyFetchSeq[variantId];
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-update-' + r.status);
      return r.json();
    }).then(function (res) {
      var isLatest = qtyFetchSeq[variantId] === mySeq;
      if (!isLatest) return res; // descartar TODO el procesamiento; el último fetch lo hará
      if (cart && typeof cart.renderContents === 'function' && res && res.sections) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(res);
      }
      if (res && typeof res.item_count === 'number') {
        applyServerBadgeIfSettled(res.item_count);
      }
      syncAllQtyControlsFromCart(res, { authoritative: true });
      delete qtyJustChanged[variantId]; // consensus reached con server, soltar el guard
      return res;
    });
  }

  // Debounce: acumulamos clicks rápidos en + y −, y solo hacemos fetch
  // con el qty final cuando el usuario para de tocar. Optimistic UI inmediato.
  function scheduleVariantQtyFetch(variantId, newQty) {
    qtyJustChanged[variantId] = Date.now(); // marca para bloquear syncs non-authoritative durante el guard window
    var entry = qtyPendingFetch[variantId];
    if (!entry) {
      cartOpsActive++;
      entry = qtyPendingFetch[variantId] = {
        timer: null,
        lastQty: newQty,
        prevQty: parseInt((document.querySelector('[data-mv-qty-wrap][data-variant-id="' + variantId + '"]') || {}).getAttribute && document.querySelector('[data-mv-qty-wrap][data-variant-id="' + variantId + '"]').getAttribute('data-qty'), 10) || 0,
        prevBadge: getMvCartBadgeCount()
      };
    } else {
      entry.lastQty = newQty;
    }
    if (entry.timer) clearTimeout(entry.timer);
    entry.timer = setTimeout(function () {
      var finalQty = entry.lastQty;
      var prevQty = entry.prevQty;
      var prevBadge = entry.prevBadge;
      delete qtyPendingFetch[variantId];
      qtyInFlight[variantId] = (qtyInFlight[variantId] || 0) + 1;
      var clearInFlight = function () {
        qtyInFlight[variantId] = (qtyInFlight[variantId] || 1) - 1;
        if (qtyInFlight[variantId] <= 0) delete qtyInFlight[variantId];
      };
      var settleOp = function () {
        cartOpsActive = Math.max(0, cartOpsActive - 1);
      };
      setVariantQty(variantId, finalQty)
        .then(function () { clearInFlight(); settleOp(); })
        .catch(function (err) {
          clearInFlight();
          settleOp();
          console.error('[mv] qty change failed', err);
          setQtyOnAllCards(variantId, prevQty, prevQty > 0 ? 'expand' : 'auto');
          applyMvCartBadgeCount(document.querySelectorAll('[data-cart-count]'), prevBadge);
        });
    }, QTY_FETCH_DEBOUNCE_MS);
  }

  document.addEventListener('click', function (e) {
    // Bubble (estado collapsed) → expandir el stepper
    var bubble = e.target.closest('[data-mv-qty-expand]');
    if (bubble) {
      e.preventDefault();
      var wrap = bubble.closest('[data-mv-qty-wrap]');
      if (!wrap) return;
      var variantId = wrap.getAttribute('data-variant-id');
      expandWrap(wrap, variantId);
      return;
    }

    var addBtn = e.target.closest('[data-mv-qty-add], [data-mv-qty-plus]');
    if (addBtn) {
      e.preventDefault();
      if (addBtn.hasAttribute('disabled')) return;
      var wrap = addBtn.closest('[data-mv-qty-wrap]');
      if (!wrap) return;
      var variantId = wrap.getAttribute('data-variant-id');
      var qty = parseInt(wrap.getAttribute('data-qty'), 10) || 0;
      var maxQty = parseInt(wrap.getAttribute('data-max-qty'), 10);
      if (!isNaN(maxQty) && qty >= maxQty) return; // ya en máximo, ignorar click
      var newQty = qty + 1;
      setQtyOnAllCards(variantId, newQty, 'expand');
      applyMvCartBadgeCount(document.querySelectorAll('[data-cart-count]'), getMvCartBadgeCount() + 1);
      scheduleVariantQtyFetch(variantId, newQty);
      return;
    }

    var minusBtn = e.target.closest('[data-mv-qty-minus]');
    if (minusBtn) {
      e.preventDefault();
      var wrap = minusBtn.closest('[data-mv-qty-wrap]');
      if (!wrap) return;
      var variantId = wrap.getAttribute('data-variant-id');
      var qty = parseInt(wrap.getAttribute('data-qty'), 10) || 0;
      if (qty <= 0) return;
      var newQty = qty - 1;
      setQtyOnAllCards(variantId, newQty, 'expand');
      applyMvCartBadgeCount(document.querySelectorAll('[data-cart-count]'), Math.max(0, getMvCartBadgeCount() - 1));
      scheduleVariantQtyFetch(variantId, newQty);
      return;
    }

    // ─── Botón "Vaciar carrito" (cart drawer y cart page) ─────────────
    var emptyBtn = e.target.closest('[data-mv-cart-empty]');
    if (emptyBtn) {
      e.preventDefault();
      if (emptyBtn.disabled) return;
      if (!window.confirm('¿Vaciar el carrito? Esta acción no se puede deshacer.')) return;
      emptyBtn.disabled = true;
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        // Reload mantiene la lógica simple: la cart page muestra estado vacío,
        // el drawer se cierra (refresh) y el badge cae a 0.
        window.location.reload();
      }).catch(function () {
        emptyBtn.disabled = false;
        window.location.reload();
      });
      return;
    }
  });

  function loadCartStateIntoCards() {
    if (!document.querySelector('[data-mv-qty-wrap]')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncAllQtyControlsFromCart)
      .catch(function () {});
  }

  // Observar cambios en el cart-drawer (cuando el usuario edita cantidades
  // dentro del drawer) y re-sincronizar los counters de las cards.
  function observeCartDrawerForSync() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; loadCartStateIntoCards(); }, 250);
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }

  function bootCartQtyControls() {
    loadCartStateIntoCards();
    observeCartDrawerForSync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCartQtyControls);
  } else {
    bootCartQtyControls();
  }

  // Reposicionar paneles abiertos al scrollear el carrusel o redimensionar:
  // el panel "sigue" al + button suavemente en cada frame. Si el toggle sale
  // completamente del viewport, sí cerramos (quedaría flotando sin contexto).
  function repositionAllOpenPanels() {
    document.querySelectorAll('.card-add-wrap.open').forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-mv-variant-toggle]');
      if (!toggle) return;
      var r = toggle.getBoundingClientRect();
      var offscreen = r.right < 0 || r.left > window.innerWidth ||
                      r.bottom < 0 || r.top > window.innerHeight;
      if (offscreen) {
        wrap.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        unmountFloatingPanel(wrap);
        return;
      }
      positionVariantPanel(wrap);
    });
  }
  var repositionScheduled = false;
  function scheduleReposition() {
    if (repositionScheduled) return;
    repositionScheduled = true;
    requestAnimationFrame(function () {
      repositionScheduled = false;
      repositionAllOpenPanels();
    });
  }
  window.addEventListener('scroll', scheduleReposition, { passive: true, capture: true });
  window.addEventListener('resize', scheduleReposition);

  // ─── Mobile drawer (hamburger) ───────────────────────────────────────
  function initDrawer() {
    var drawer = document.getElementById('mv-drawer');
    if (!drawer) {
      console.warn('[mv-drawer] #mv-drawer no encontrado en DOM');
      return;
    }
    if (drawer.dataset.mvDrawerInit === '1') return; // ya inicializado
    drawer.dataset.mvDrawerInit = '1';

    // Mover el drawer a <body> para que `position: fixed` se ancle al viewport
    // sin riesgo de containing-block creado por wrappers de Shopify section
    // (transform, sticky, contain, backdrop-filter en ancestros).
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    var panel = drawer.querySelector('.mv-drawer');
    var openers = document.querySelectorAll('[data-mv-open-drawer]');
    var closers = drawer.querySelectorAll('[data-mv-close-drawer]');
    var html = document.documentElement;
    var lastOpener = null;

    if (openers.length === 0) {
      console.warn('[mv-drawer] no hay [data-mv-open-drawer] en la página');
    }

    function openDrawer(e) {
      if (e) {
        e.preventDefault();
        lastOpener = e.currentTarget || null;
      }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (panel) panel.setAttribute('aria-modal', 'true');
      html.classList.add('no-scroll');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (typeof trapFocus === 'function' && panel) {
        var firstFocusable = panel.querySelector('button, a');
        trapFocus(panel, firstFocusable || panel);
      }
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (panel) panel.removeAttribute('aria-modal');
      html.classList.remove('no-scroll');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(lastOpener || undefined);
      } else if (lastOpener && typeof lastOpener.focus === 'function') {
        lastOpener.focus();
      }
    }

    openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
    closers.forEach(function (b) { b.addEventListener('click', closeDrawer); });

    // Toggle de submenús: expande/colapsa sin cerrar el drawer
    drawer.querySelectorAll('[data-mv-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var targetId = btn.getAttribute('aria-controls');
        var target = targetId ? document.getElementById(targetId) : null;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (target) {
          if (expanded) {
            target.setAttribute('hidden', '');
          } else {
            target.removeAttribute('hidden');
          }
        }
      });
    });

    // Cerrar drawer al tap en links de navegación REAL (no en toggles)
    drawer.querySelectorAll('a.drawer-link, a.drawer-sublink').forEach(function (a) {
      a.addEventListener('click', function () { closeDrawer(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Swipe-to-close: el drawer entra desde la derecha (translateX 100% → 0).
    // Un swipe horizontal hacia la derecha lo arrastra fuera del viewport.
    // Si pasa 80px o supera el 30% del ancho, lo cerramos al soltar.
    if (panel) {
      var sX = 0, sY = 0, lastX = 0;
      var axis = null; // null | 'h' | 'v'
      panel.addEventListener('touchstart', function (e) {
        if (!drawer.classList.contains('is-open') || e.touches.length !== 1) return;
        sX = lastX = e.touches[0].clientX;
        sY = e.touches[0].clientY;
        axis = null;
        panel.style.transition = 'none';
      }, { passive: true });

      panel.addEventListener('touchmove', function (e) {
        if (!drawer.classList.contains('is-open') || e.touches.length !== 1) return;
        var t = e.touches[0];
        var dx = t.clientX - sX;
        var dy = t.clientY - sY;
        var ax = Math.abs(dx);
        var ay = Math.abs(dy);
        if (axis === null) {
          if (ax + ay < 8) return;
          // Solo lockeamos como horizontal si es claramente lateral Y hacia
          // la derecha (= dirección de cierre). Vertical = scroll del menú.
          axis = (ax > ay * 1.4 && dx > 0) ? 'h' : 'v';
        }
        if (axis === 'h') {
          panel.style.transform = 'translateX(' + Math.max(0, dx) + 'px)';
        }
        lastX = t.clientX;
      }, { passive: true });

      panel.addEventListener('touchend', function () {
        if (!drawer.classList.contains('is-open')) return;
        panel.style.transition = '';
        if (axis === 'h') {
          var dx = lastX - sX;
          var threshold = Math.min(80, panel.offsetWidth * 0.3);
          panel.style.transform = '';
          if (dx > threshold) closeDrawer();
        } else {
          panel.style.transform = '';
        }
        axis = null;
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }

  // ─── Carousel nav buttons (.car-nav) ─────────────────────────────────
  function initCarNav() {
    document.querySelectorAll('.car-nav').forEach(function (nav) {
      if (nav.dataset.mvCarNavInit === '1') return;
      nav.dataset.mvCarNavInit = '1';
      var sel = nav.getAttribute('data-car-target');
      if (!sel) return;
      var track = document.querySelector(sel);
      if (!track) return;
      var prev = nav.querySelector('.car-btn.prev');
      var next = nav.querySelector('.car-btn.next');

      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth * 0.8;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }
      // Track del último destino programático: si el usuario click rápido
      // mientras la animación smooth aún corre, scrollLeft no refleja el
      // target todavía. Usar lastTarget para que clicks consecutivos avancen
      // sin "atascarse" en el mismo snap.
      var lastTarget = null;
      function snappedTarget(direction) {
        var s = step();
        if (s <= 0) return track.scrollLeft;
        var current = lastTarget != null ? lastTarget : track.scrollLeft;
        // round al snap más cercano y después +/- direction. Math.round
        // tolera errores de subpixel (step varía ligeramente por
        // getBoundingClientRect) que con floor/ceil hacen que el índice
        // se "atasque" en el mismo card.
        var currentIdx = Math.round(current / s);
        var targetIdx = currentIdx + direction;
        var max = track.scrollWidth - track.clientWidth;
        var maxIdx = Math.round(max / s);
        if (targetIdx < 0) targetIdx = 0;
        if (targetIdx > maxIdx) targetIdx = maxIdx;
        var target = targetIdx * s;
        if (target < 0) target = 0;
        if (target > max) target = max;
        return target;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = max <= 0 || track.scrollLeft >= max - 1;
      }
      // Throttle update via rAF para no recalcular layout en cada scroll event
      var rafId = null;
      function scheduleUpdate() {
        if (rafId) return;
        rafId = requestAnimationFrame(function () {
          update();
          rafId = null;
        });
      }
      if (prev) prev.addEventListener('click', function () {
        var t = snappedTarget(-1);
        lastTarget = t;
        track.scrollTo({ left: t, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        var t = snappedTarget(1);
        lastTarget = t;
        track.scrollTo({ left: t, behavior: 'smooth' });
      });
      // Reset lastTarget cuando el scroll efectivamente llega cerca del target
      // (margen 2px) o cuando el usuario hace un scroll manual fuera de él.
      track.addEventListener('scroll', function () {
        if (lastTarget != null && Math.abs(track.scrollLeft - lastTarget) < 2) {
          lastTarget = null;
        }
        scheduleUpdate();
      }, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarNav);
  } else {
    initCarNav();
  }

  // ─── Auto-rotación de testimonios solo en mobile ─────────────────────
  // Desktop ≥1101px: layout grid de 2 reseñas apiladas, sin autoplay.
  // Mobile ≤1100px: carrusel scroll-snap con autoplay cada 5s.
  function initTestimonialsAutoplay() {
    document.querySelectorAll('[data-mv-testi-autoplay]').forEach(function (list) {
      var cards = list.querySelectorAll('.testi-card');
      var n = cards.length;
      if (n < 2) return;

      var mqMobile = window.matchMedia('(max-width: 1100px)');
      var dotsWrap = list.parentElement && list.parentElement.querySelector('[data-mv-testi-dots]');
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.testi-dot') : [];
      var stateClasses = ['is-front-1', 'is-front-2', 'is-back-1', 'is-back-2', 'is-active', 'is-prev'];

      var pairCount = Math.ceil(n / 2);
      var pairIndex = 0;
      var mobileIndex = 0;
      var intervalId = null;
      var paused = false;

      function clearStates() {
        for (var i = 0; i < n; i++) {
          for (var k = 0; k < stateClasses.length; k++) {
            cards[i].classList.remove(stateClasses[k]);
          }
        }
      }

      function syncDots(activeIdx) {
        for (var j = 0; j < dots.length; j++) {
          dots[j].classList.toggle('is-active', j === activeIdx);
        }
      }

      function applyDesktop() {
        var f1 = (pairIndex * 2) % n;
        var f2 = (pairIndex * 2 + 1) % n;
        var b1 = (f1 + 2) % n;
        var b2 = (f2 + 2) % n;
        clearStates();
        if (cards[f1]) cards[f1].classList.add('is-front-1');
        if (cards[f2] && f2 !== f1) cards[f2].classList.add('is-front-2');
        if (cards[b1] && b1 !== f1 && b1 !== f2) cards[b1].classList.add('is-back-1');
        if (cards[b2] && b2 !== f1 && b2 !== f2 && b2 !== b1) cards[b2].classList.add('is-back-2');
        syncDots(-1);
      }

      function applyMobile(prevIdx) {
        for (var i = 0; i < n; i++) {
          var c = cards[i];
          c.classList.remove('is-front-1', 'is-front-2', 'is-back-1', 'is-back-2');
          if (i === mobileIndex) {
            c.classList.remove('is-prev');
            c.classList.add('is-active');
          } else if (i === prevIdx) {
            c.classList.remove('is-active');
            c.classList.add('is-prev');
          } else {
            c.classList.remove('is-active', 'is-prev');
          }
        }
        syncDots(mobileIndex);
      }

      function reset() {
        clearStates();
        if (mqMobile.matches) {
          mobileIndex = 0;
          applyMobile(-1);
        } else {
          pairIndex = 0;
          applyDesktop();
        }
      }

      function tick() {
        if (paused || document.hidden) return;
        if (mqMobile.matches) {
          var prevIdx = mobileIndex;
          mobileIndex = (mobileIndex + 1) % n;
          applyMobile(prevIdx);
        } else {
          pairIndex = (pairIndex + 1) % pairCount;
          applyDesktop();
        }
      }

      function start() {
        if (!intervalId) intervalId = setInterval(tick, 5000);
      }

      list.addEventListener('mouseenter', function () { paused = true; });
      list.addEventListener('mouseleave', function () { paused = false; });
      list.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      list.addEventListener('touchend', function () {
        setTimeout(function () { paused = false; }, 4000);
      }, { passive: true });

      for (var i = 0; i < dots.length; i++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            if (!mqMobile.matches) return;
            var idx = parseInt(dot.getAttribute('data-index'), 10) || 0;
            if (idx === mobileIndex) return;
            var prevIdx = mobileIndex;
            mobileIndex = idx;
            applyMobile(prevIdx);
            paused = true;
            setTimeout(function () { paused = false; }, 6000);
          });
        })(dots[i]);
      }

      reset();
      start();

      var onMqChange = function () { reset(); };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onMqChange);
      else if (mqMobile.addListener) mqMobile.addListener(onMqChange);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialsAutoplay);
  } else {
    initTestimonialsAutoplay();
  }

  // ─── Deduplicar productos en carruseles del home ─────────────────────
  // Cada section renderiza ~30 cards de buffer (mv-product-grid.liquid
  // → render_count). El dedupe ordena los carruseles por
  // data-dedupe-priority DESC: el carrusel más escaso (mayor prioridad)
  // reclama primero los productos compartidos, los abundantes ceden.
  // Tie-breaker: orden DOM. Cada carrusel queda capeado en TARGET cards.
  function dedupeHomeCarousels() {
    var grids = document.querySelectorAll('.mv-grid-block .products');
    if (grids.length < 2) return;
    var ordered = Array.prototype.slice.call(grids).map(function (grid, idx) {
      var section = grid.closest('.mv-grid-block');
      var prio = section ? parseInt(section.getAttribute('data-dedupe-priority') || '0', 10) : 0;
      return { grid: grid, prio: isNaN(prio) ? 0 : prio, idx: idx };
    });
    ordered.sort(function (a, b) {
      return (b.prio - a.prio) || (a.idx - b.idx);
    });
    var seen = Object.create(null);
    var TARGET = 10;
    ordered.forEach(function (entry) {
      var kept = 0;
      entry.grid.querySelectorAll('.card[data-product-id]').forEach(function (card) {
        var id = card.getAttribute('data-product-id');
        if (!id) { card.remove(); return; }
        if (seen[id] || kept >= TARGET) {
          card.remove();
        } else {
          seen[id] = true;
          kept++;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dedupeHomeCarousels);
  } else {
    dedupeHomeCarousels();
  }

  // ─── Swipe-to-close del cart drawer (mobile) ─────────────────────────
  // El drawer entra desde la derecha (translateX 100% → 0). Un swipe hacia
  // la derecha sigue al dedo y, si pasa el umbral, llama a .close().
  function initCartDrawerSwipe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.mvSwipeInit === '1') return;
    drawer.dataset.mvSwipeInit = '1';

    var inner = drawer.querySelector('#CartDrawer');
    if (!inner) return;

    var THRESHOLD = 100;       // px para confirmar cierre
    var DIR_LOCK = 10;         // px antes de decidir horizontal vs vertical
    var startX = 0, startY = 0, deltaX = 0;
    var dragging = false, locked = false, prevTransition = '';

    function onPointerDown(e) {
      if (e.pointerType !== 'touch') return;
      if (!drawer.classList.contains('active')) return;
      // No interceptar si el touch arranca sobre un control interactivo o en
      // el overlay (que ya cierra al tap).
      if (e.target.closest('button, a, input, textarea, select, [contenteditable], #CartDrawer-Overlay')) return;
      startX = e.clientX;
      startY = e.clientY;
      deltaX = 0;
      dragging = true;
      locked = false;
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!locked) {
        if (Math.abs(dx) < DIR_LOCK && Math.abs(dy) < DIR_LOCK) return;
        // Si gana vertical, el usuario está scrolleando: cancelar gesto.
        if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
        locked = true;
        prevTransition = inner.style.transition;
        inner.style.transition = 'none';
      }
      // Solo seguir el dedo cuando arrastra a la derecha (cierre).
      deltaX = Math.max(0, dx);
      inner.style.transform = 'translateX(' + deltaX + 'px)';
      if (e.cancelable) e.preventDefault();
    }

    function reset() {
      inner.style.transition = prevTransition;
      inner.style.transform = '';
    }

    function onPointerUp() {
      if (!dragging) return;
      var shouldClose = locked && deltaX > THRESHOLD;
      dragging = false;
      locked = false;
      if (shouldClose) {
        // Soltar estilos inline para que la transición CSS de cierre tome el control.
        reset();
        if (typeof drawer.close === 'function') drawer.close();
      } else {
        // Snap back con transición.
        inner.style.transition = prevTransition || '';
        inner.style.transform = '';
      }
    }

    drawer.addEventListener('pointerdown', onPointerDown, { passive: true });
    drawer.addEventListener('pointermove', onPointerMove, { passive: false });
    drawer.addEventListener('pointerup', onPointerUp, { passive: true });
    drawer.addEventListener('pointercancel', onPointerUp, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerSwipe);
  } else {
    initCartDrawerSwipe();
  }

  // ─── Icono del carrito (header) abre drawer en vez de navegar a /cart ──
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mv-open-cart]');
    if (!trigger) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    drawer.open();
  });

  // ─── Sincronizar el badge del carrito con cart-update (remove/qty change) ──
  // PUB_SUB_EVENTS es `const` top-level en pubsub.js → NO va a window. Solo
  // accesible por bare identifier o hardcoded string. El event name es 'cart-update'.
  // `subscribe` sí está en window porque es `function`.
  function refreshCartBadgeFromCartJs() {
    var badges = document.querySelectorAll('[data-cart-count]');
    if (!badges.length) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { applyServerBadgeIfSettled(c.item_count); })
      .catch(function () {});
  }

  function tryHookCartUpdateSubscribe() {
    var sub = (typeof subscribe === 'function') ? subscribe : (typeof window.subscribe === 'function' ? window.subscribe : null);
    if (!sub) return false;
    sub('cart-update', function (payload) {
      var count = (payload && payload.cartData && typeof payload.cartData.item_count === 'number')
        ? payload.cartData.item_count : null;
      var badges = document.querySelectorAll('[data-cart-count]');
      if (!badges.length) return;
      if (count !== null) applyServerBadgeIfSettled(count);
      else refreshCartBadgeFromCartJs();
    });
    return true;
  }
  // pubsub.js carga con defer; puede no estar listo cuando este script corre.
  if (!tryHookCartUpdateSubscribe()) {
    document.addEventListener('DOMContentLoaded', tryHookCartUpdateSubscribe);
  }

  // Defensa adicional: hookear el `productCreateMedia` del cart.js no es viable,
  // así que monitoreo cambios en el DOM del drawer (cart items added/removed).
  // Cuando el cart-drawer se re-renderiza, contamos los <li> y actualizamos.
  // Esto cubre casos donde el pubsub falla por timing o load order.
  function watchCartDrawerForChanges() {
    var drawerInner = document.querySelector('cart-drawer #CartDrawer');
    if (!drawerInner) {
      setTimeout(watchCartDrawerForChanges, 500);
      return;
    }
    var refreshTimer;
    var mo = new MutationObserver(function () {
      // Debounce 200ms — evita N requests durante un render burst
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshCartBadgeFromCartJs, 200);
    });
    mo.observe(drawerInner, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartDrawerForChanges);
  } else {
    watchCartDrawerForChanges();
  }

  // ─── Client-side bg removal via canvas flood-fill ──────────────────
  // Sin AI, sin uploads. Cuando la card entra en viewport, descarga la foto
  // con CORS, dibuja en canvas, samplea 4 esquinas. Si son uniformes, hace
  // flood-fill desde cada esquina con tolerancia → pone alpha=0 a esos
  // pixels → reemplaza img.src con un Blob URL transparente. El wrap default
  // queda visible detrás. Si el bg no es uniforme (lifestyle) → no toca nada.
  function initBgFloodFill() {
    var SELECTORS = '.card-erewhon .card-img, .mv-cl-card__media img, .mv-cl-grid .cat-card-bg';
    var COLOR_TOL = 45;        // similitud entre 4 esquinas para "bg uniforme"
    var FILL_TOL = 38;         // tolerancia del flood fill desde el color de bg
    var MAX_DIM = 500;         // cap para que no procese 3000px (500 → ~2.5x más rápido que 800)

    // Counter visible en consola: window.__mvBgFf
    window.__mvBgFf = window.__mvBgFf || { tried: 0, replaced: 0, skipped: 0, errors: 0 };

    function similar(a, b) {
      return Math.abs(a[0]-b[0]) <= COLOR_TOL
          && Math.abs(a[1]-b[1]) <= COLOR_TOL
          && Math.abs(a[2]-b[2]) <= COLOR_TOL;
    }

    function reveal(imgEl) {
      imgEl.classList.add('mv-bg-ready');
    }

    function process(imgEl, done) {
      done = done || function () {};
      if (imgEl.dataset.mvBgFf) { reveal(imgEl); done(); return; }
      imgEl.dataset.mvBgFf = '1';

      var src = imgEl.currentSrc || imgEl.src;
      if (!src) { reveal(imgEl); done(); return; }
      window.__mvBgFf.tried++;

      // Estrategia: fetch() para obtener un Blob (no Image), luego convertir el Blob
      // a object URL y cargarlo en un nuevo Image. El blob URL es same-origin, así
      // que el canvas no queda tainted, sin importar el cache del browser.
      fetch(src, { mode: 'cors', credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('fetch ' + r.status);
          return r.blob();
        })
        .then(function (blob) {
          return new Promise(function (resolve, reject) {
            var probe = new Image();
            var probeUrl = URL.createObjectURL(blob);
            probe.onload = function () {
              // Resolvemos con el probe Y la URL para revocar después de drawImage
              resolve({ probe: probe, url: probeUrl });
            };
            probe.onerror = function (err) {
              URL.revokeObjectURL(probeUrl);
              reject(err);
            };
            probe.src = probeUrl;
          });
        })
        .then(function (ctx2) {
          var probe = ctx2.probe;
          var probeUrl = ctx2.url;
          try {
          // Cap dimensiones
          var w = probe.naturalWidth, h = probe.naturalHeight;
          if (w > MAX_DIM || h > MAX_DIM) {
            var k = MAX_DIM / Math.max(w, h);
            w = Math.round(w * k);
            h = Math.round(h * k);
          }
          var canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(probe, 0, 0, w, h);
          // Liberar el probe blob URL: ya tenemos los pixeles en el canvas
          URL.revokeObjectURL(probeUrl);
          probe.src = '';
          var imgData = ctx.getImageData(0, 0, w, h);
          var data = imgData.data;

          function pix(x, y) {
            var i = (y * w + x) * 4;
            return [data[i], data[i+1], data[i+2]];
          }
          var corners = [pix(0,0), pix(w-1,0), pix(0,h-1), pix(w-1,h-1)];

          // Validar uniformidad de las 4 esquinas
          if (!similar(corners[0], corners[1]) ||
              !similar(corners[0], corners[2]) ||
              !similar(corners[0], corners[3])) {
            window.__mvBgFf.skipped++;
            reveal(imgEl);
            // Liberar memoria antes de salir (canvas + imgData no se usan más)
            canvas.width = 0; canvas.height = 0;
            imgData = null; data = null;
            done();
            return; // bg no uniforme — no tocamos
          }

          var bg = [
            (corners[0][0]+corners[1][0]+corners[2][0]+corners[3][0]) / 4,
            (corners[0][1]+corners[1][1]+corners[2][1]+corners[3][1]) / 4,
            (corners[0][2]+corners[1][2]+corners[2][2]+corners[3][2]) / 4
          ];

          // Flood fill BFS con head pointer (O(n))
          var visited = new Uint8Array(w * h);
          var queue = new Int32Array(w * h);
          var qhead = 0, qtail = 0;

          function tryAdd(x, y) {
            if (x < 0 || y < 0 || x >= w || y >= h) return;
            var idx = y * w + x;
            if (visited[idx]) return;
            var i = idx * 4;
            if (Math.abs(data[i]-bg[0]) > FILL_TOL ||
                Math.abs(data[i+1]-bg[1]) > FILL_TOL ||
                Math.abs(data[i+2]-bg[2]) > FILL_TOL) return;
            visited[idx] = 1;
            data[i+3] = 0; // alpha 0 → transparente
            queue[qtail++] = idx;
          }

          tryAdd(0, 0); tryAdd(w-1, 0); tryAdd(0, h-1); tryAdd(w-1, h-1);

          while (qhead < qtail) {
            var idx = queue[qhead++];
            var x = idx % w, y = (idx - x) / w;
            tryAdd(x+1, y); tryAdd(x-1, y); tryAdd(x, y+1); tryAdd(x, y-1);
          }

          ctx.putImageData(imgData, 0, 0);
          canvas.toBlob(function (blob) {
            if (blob) {
              // CRÍTICO: srcset tiene prioridad sobre src en browsers modernos.
              // Si no lo borramos, el browser sigue mostrando la imagen original
              // (con fondo) en vez de nuestro blob URL transparente.
              imgEl.removeAttribute('srcset');
              imgEl.removeAttribute('sizes');
              imgEl.src = URL.createObjectURL(blob);
              window.__mvBgFf.replaced++;
              imgEl.addEventListener('load', function () { reveal(imgEl); }, { once: true });
            } else {
              reveal(imgEl);
            }
            // Liberar canvas + typed arrays grandes: ya no los necesitamos
            canvas.width = 0; canvas.height = 0;
            imgData = null; data = null; visited = null; queue = null;
            done();
          }, 'image/png');
        } catch (e) {
          window.__mvBgFf.errors++;
          reveal(imgEl);
          done();
          /* canvas read fail — silent */
        }
        })
        .catch(function (e) {
          window.__mvBgFf.errors++;
          reveal(imgEl);
          done();
          /* fetch fail — silent */
        });
    }

    // Concurrencia 4 (era 8). Combinado con IntersectionObserver, la cola
    // procesa solo lo visible. Bajar de 8 a 4 reduce el pico de memoria a la
    // mitad (cada inflight retiene canvas + typed arrays + blob durante
    // ~300ms). Con scroll intenso disparando muchos intersect events, esto
    // evita OOM crashes del renderer del browser.
    var queue = [];
    var inflight = 0;
    var MAX_INFLIGHT = 4;
    function pump() {
      while (inflight < MAX_INFLIGHT && queue.length > 0) {
        var img = queue.shift();
        inflight++;
        process(img, function () { inflight--; pump(); });
      }
    }

    function bind(img) {
      queue.push(img);
      pump();
    }

    // IntersectionObserver: solo procesar imágenes que están visibles o por
    // entrar al viewport (rootMargin 200px = preload). En el home con 60+
    // cards en carruseles horizontales, esto evita procesar las que están
    // fuera del scroll horizontal hasta que el usuario las vaya a ver.
    var bgFfObserver = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var img = entry.target;
            bgFfObserver.unobserve(img);
            if (img.complete && img.naturalWidth > 0) bind(img);
            else img.addEventListener('load', function () { bind(img); }, { once: true });
          });
        }, { rootMargin: '200px', threshold: 0 })
      : null;

    function scan() {
      document.querySelectorAll(SELECTORS).forEach(function (img) {
        if (img.dataset.mvBgFfBound) return;
        img.dataset.mvBgFfBound = '1';
        if (bgFfObserver) {
          bgFfObserver.observe(img);
        } else {
          // Fallback: procesar inmediatamente
          if (img.complete && img.naturalWidth > 0) bind(img);
          else img.addEventListener('load', function () { bind(img); }, { once: true });
        }
      });
    }

    scan();
    var mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBgFloodFill);
  } else {
    initBgFloodFill();
  }

  // ─── Liberar wheel vertical sobre carruseles horizontales ────────────
  // Sin esto, los contenedores con overflow-x: auto + scroll-snap pueden
  // "atrapar" el wheel vertical y mover el carrusel en vez de la página.
  // Acumulamos deltaY entre wheel events y aplicamos scrollBy una vez por
  // frame con rAF — durante scroll intenso el handler dispara cientos de
  // veces por segundo y llamar scrollBy en cada uno satura el main thread.
  function initCarouselWheelFix() {
    var selectors = [
      '.testi-list',
      '.products',
      '.cat-carousel',
      '.diets',
      '.banner-track'
    ];
    var pendingDeltaY = 0;
    var rafId = 0;
    function flush() {
      rafId = 0;
      if (pendingDeltaY !== 0) {
        window.scrollBy(0, pendingDeltaY);
        pendingDeltaY = 0;
      }
    }
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      el.addEventListener('wheel', function (e) {
        // Solo intervenir si el carrusel es realmente scrollable horizontal
        if (el.scrollWidth <= el.clientWidth + 1) return;
        // Si el wheel es predominantemente vertical, scroll de página
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX) * 1.2) {
          pendingDeltaY += e.deltaY;
          if (!rafId) rafId = requestAnimationFrame(flush);
          e.preventDefault();
        }
      }, { passive: false });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselWheelFix);
  } else {
    initCarouselWheelFix();
  }

  // ─── Scroll-driven animations (Apple-style) ──────────────────────────
  // Reveal: IntersectionObserver añade .in-view a [data-mv-anim] al entrar
  // al viewport. Stagger: el padre [data-mv-stagger="0.08"] reparte delays
  // incrementales entre sus hijos animables. Parallax: rAF actualiza la CSS
  // var --mv-parallax-y según la posición del elemento.
  function initScrollAnimations() {
    var prm = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (prm.matches) {
      document.querySelectorAll('[data-mv-anim]').forEach(function (el) {
        el.classList.add('in-view');
      });
      return;
    }

    // Stagger: aplicar delay incremental a hijos animables (idempotente —
    // skip cualquier hijo que ya tenga --mv-anim-delay seteado).
    function applyStagger() {
      document.querySelectorAll('[data-mv-stagger]').forEach(function (parent) {
        var step = parseFloat(parent.dataset.mvStagger) || 0.08;
        var max = parseFloat(parent.dataset.mvStaggerMax) || 0.6;
        var children = parent.querySelectorAll('[data-mv-anim]');
        children.forEach(function (child, i) {
          if (child.style.getPropertyValue('--mv-anim-delay')) return;
          var delay = Math.min(i * step, max);
          child.style.setProperty('--mv-anim-delay', delay + 's');
        });
      });
    }
    applyStagger();

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-mv-anim]').forEach(function (el) {
        el.classList.add('in-view');
      });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          } else {
            entry.target.classList.remove('in-view');
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      function observePendingAnims() {
        document.querySelectorAll('[data-mv-anim]').forEach(function (el) {
          if (el.dataset.mvAnimObserved) return;
          el.dataset.mvAnimObserved = '1';
          io.observe(el);
        });
      }
      observePendingAnims();

      // Cards inyectadas por AJAX (ej: <product-recommendations> en el PDP)
      // no existen al primer scan → quedaban con opacity:0 ("fantasma":
      // hover muestra cursor pointer porque el <a> existe, pero el contenido
      // es invisible). Vigilamos el DOM y observamos los nuevos.
      var animMo = new MutationObserver(function (mutations) {
        var foundNew = false;
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('[data-mv-anim]')) { foundNew = true; break; }
            if (n.querySelector && n.querySelector('[data-mv-anim]')) { foundNew = true; break; }
          }
          if (foundNew) break;
        }
        if (foundNew) {
          applyStagger();
          observePendingAnims();
        }
      });
      animMo.observe(document.body, { childList: true, subtree: true });
    }

    // Parallax: rAF loop, una pasada por scroll/resize
    var parallaxEls = Array.prototype.slice.call(
      document.querySelectorAll('[data-mv-parallax]')
    );
    if (parallaxEls.length === 0) return;

    var ticking = false;
    function updateParallax() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      parallaxEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // Solo procesar si está cerca del viewport
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var center = rect.top + rect.height / 2;
        var progress = (center - vh / 2) / vh; // -1 (debajo) a 1 (arriba)
        var speed = parseFloat(el.dataset.mvParallax) || 0.25;
        var y = -progress * speed * 100; // px
        el.style.setProperty('--mv-parallax-y', y.toFixed(2) + 'px');
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateParallax();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }
})();
